<template lang="pug">
p(:class="classArray", :style="styleObject", v-on="$listeners", v-bind="$attrs") 
  slot {{ text }}
</template>

<script lang="ts">
import Vue from "vue"
import THEME from "../../constants/theme"
const { subtitle, rootFontSize } = THEME.typography
export default Vue.extend({
  name: "Subtitle",
  props: {
    text: { type: String, required: false },
    fontSize: { type: Number, default: 1 },
    customClass: { type: String, default: "" },
    fontWeight: { type: Number, default: 700 },
    color: { type: String, default: "textColor" },
    lineHeight: { type: Number },
  },
  computed: {
    setColor(): string | undefined {
      switch (this.color) {
        case "primary":
          return this.$vuetify.theme.themes.light.primary?.toString()
        case "textColor":
          return this.$vuetify.theme.themes.light.textColor?.toString()
        default:
          return `${this.color}`
      }
    },
    styleObject(): object {
      return {
        color: this.setColor,
        ...subtitle,
        ...(this.fontWeight && { fontWeight: this.fontWeight }),
        ...(this.fontSize && {
          fontSize: `${this.fontSize * rootFontSize}px !important`,
          lineHeight: this.lineHeight ? `${this.lineHeight}px !important` : `${this.fontSize * 1.5 * rootFontSize}px !important`,
        }),
      }
    },
    classArray(): string[] {
      return [`text-subtitle-1 suus__subtitle`, `${this.customClass}`]
    },
  },
})
</script>

